




























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { login } from '../api/auth';

@Component
export default class Login extends Vue {
  @Prop()
  public error!: string | null;

  @Prop({
    default: '',
  })
  public email!: string;

  @Prop({
    default: false,
    type: Boolean,
  })
  public isSp!: boolean;

  private errorText: string | null = '';
  private emailText = '';
  private password = '';
  private loading = false;
  private userError: string | null = null;
  private passwordError: string | null = null;
  private valid = false;

  private created() {
    this.emailText = this.email;
    this.errorText = this.error;
  }

  private async login() {
    this.loading = true;
    this.userError = null;
    this.passwordError = null;

    try {
      const ret = await login({
        email: this.emailText,
        password: this.password,
        sp: this.isSp,
      });
      this.loading = false;

      if (!ret.success) {
        this.errorText = 'Login Failure';
        return;
      }

      this.$router.push('/app/measure');
    } catch (err) {
      console.log(err);
    }
  }
}
